import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, ViewChild, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["numericInput"];
function NumericSelectorComponent__svg_svg_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 11);
    i0.ɵɵelement(1, "path", 12);
    i0.ɵɵelementEnd();
  }
}
function NumericSelectorComponent__svg_svg_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 13);
    i0.ɵɵelement(1, "path", 14);
    i0.ɵɵelementEnd();
  }
}
function NumericSelectorComponent__svg_svg_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 15);
    i0.ɵɵelement(1, "path", 16);
    i0.ɵɵelementEnd();
  }
}
function NumericSelectorComponent__svg_svg_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 13);
    i0.ɵɵelement(1, "path", 17);
    i0.ɵɵelementEnd();
  }
}
class NumericSelectorComponent {
  constructor(cdr, renderer) {
    this.cdr = cdr;
    this.renderer = renderer;
    this.mouseFocused = false;
    this.step = 1;
    this.buttonType = false;
    this.errorMessageText = null;
    this.valueChange = new EventEmitter();
    /**
     * The registered callback function called when a change event occurs on the numeric selector element.
     */
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    /**
     * The registered callback function called when a blur event occurs on the numeric selector element.
     */
    this.onTouchedCallback = () => {};
    this.onInput = newValue => {
      clearTimeout(this.automaticResetDebouncer);
      if (!newValue || newValue === '-0') {
        // -0 important //
        return;
      }
      if (this.valueMatchMinRestriction(parseFloat(newValue)) === false) {
        return this.reset(this.min);
      }
      if (this.valueMatchMaxRestriction(parseFloat(newValue)) === false) {
        return this.reset(this.max);
      }
      this.inputedValue = newValue;
      this.doNumberChanged();
    };
    this.onBlur = () => {
      this.onTouchedCallback();
    };
    this.valueMatchMinRestriction = value => {
      return typeof this.min !== 'number' || value >= this.min ? true : false;
    };
    this.valueMatchMaxRestriction = value => {
      return typeof this.max !== 'number' || value <= this.max ? true : false;
    };
    this.reset = value => {
      this.automaticResetDebouncer = setTimeout(() => {
        if (this.inputedValue !== value) {
          this.inputedValue = value;
          this.valueChange.emit(String(this.inputedValue));
        }
        this.onInputedValueChanged();
      }, 600);
    };
    this.setInitialValue = maxOrMin => {
      let initialValue;
      if (this.min && this.max && (this.min > 0 || this.max < 0)) {
        initialValue = maxOrMin === 'max' ? this.max : this.min;
      } else {
        initialValue = 0;
      }
      this.writeValue(initialValue);
      return initialValue;
    };
    this.add = (value, step) => {
      return Math.round((value + step + Number.EPSILON) * 100) / 100;
    };
    if (this.min && this.max && this.min > this.max) {
      this.max = this.min;
    }
  }
  increment() {
    if (this.disabled) {
      return;
    }
    if (typeof this.value !== 'number') {
      this.setInitialValue('min');
    }
    const num = this.add(this.value, this.step);
    if (num > this.max) {
      return;
    }
    this.inputedValue = num;
    this.doNumberChanged();
  }
  /**
   * take the value backwards step steps
   */
  decrement() {
    if (this.disabled) {
      return;
    }
    if (typeof this.value !== 'number') {
      this.setInitialValue('max');
    }
    const num = this.add(this.value, -this.step);
    if (num < this.min) {
      return;
    }
    this.inputedValue = num;
    this.doNumberChanged();
  }
  /**
   * Registers a function called when the control value changes.
   */
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  /**
   * Registers a function called when the control is touched.
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * Write a value to the html element
   */
  writeValue(value) {
    this.value = this.parseToNumber(value);
    this.inputedValue = this.parseToNumber(value);
    this.cdr.markForCheck();
    if (this.numericInput) {
      this.renderer.setProperty(this.numericInput.nativeElement, 'value', this.value);
    }
  }
  /**
   * every change in the value
   */
  onInputedValueChanged() {
    this.writeValue(this.inputedValue);
    this.onChangedCallback(this.value);
  }
  doNumberChanged() {
    this.onInputedValueChanged();
    this.valueChange.emit(String(this.inputedValue));
  }
  parseToNumber(value) {
    if (typeof value === 'string' && value) {
      return parseFloat(value);
    }
    return value;
  }
  onMouseUp() {
    this.mouseFocused = true;
  }
  onFocusOut() {
    if (!this.inputedValue || this.inputedValue !== '-0') {
      this.onInputedValueChanged();
    }
    this.mouseFocused = false;
  }
  static {
    this.ɵfac = function NumericSelectorComponent_Factory(t) {
      return new (t || NumericSelectorComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NumericSelectorComponent,
      selectors: [["sol-numeric-selector"]],
      viewQuery: function NumericSelectorComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.numericInput = _t.first);
        }
      },
      inputs: {
        value: "value",
        step: "step",
        buttonType: "buttonType",
        name: "name",
        required: "required",
        errorMessageText: "errorMessageText",
        disabled: "disabled",
        min: "min",
        max: "max",
        placeholder: "placeholder"
      },
      outputs: {
        valueChange: "valueChange"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: NumericSelectorComponent,
        multi: true
      }])],
      decls: 14,
      vars: 19,
      consts: [[1, "sol-numeric-selector"], [1, "numeric-input-wrapper"], ["type", "number", 3, "step", "value", "min", "required", "name", "max", "placeholder", "disabled", "input", "blur", "mouseup", "focusout"], ["numericInput", ""], [1, "numeric-buttons"], ["aria-label", "increment button", 1, "top-button", 3, "disabled", "click"], ["width", "8", "height", "8", "viewBox", "0 0 8 8", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["width", "10", "height", "6", "viewBox", "0 0 10 6", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["aria-label", "decrement button", 1, "bottom-button", 3, "disabled", "click"], ["width", "8", "height", "2", "viewBox", "0 0 8 2", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], [1, "error-message"], ["width", "8", "height", "8", "viewBox", "0 0 8 8", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M8 3.5H4.5V0H3.5V3.5H0V4.5H3.5V8H4.5V4.5H8V3.5Z", "fill", "#191919"], ["width", "10", "height", "6", "viewBox", "0 0 10 6", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M5.59706 0.73624L9.65677 4.5853C9.84781 4.76643 9.84781 5.08341 9.65677 5.26454C9.46572 5.44567 9.13139 5.44567 8.94035 5.26454L5.11945 1.6419L1.05975 5.26454C0.868705 5.44567 0.534376 5.44567 0.343331 5.26454C0.152287 5.08341 0.152286 4.76643 0.343331 4.5853L4.64184 0.73624C4.78512 0.600391 4.92841 0.600391 5.07169 0.600391C5.3105 0.600391 5.50154 0.645674 5.59706 0.73624Z", "fill", "#191919"], ["width", "8", "height", "2", "viewBox", "0 0 8 2", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0 0.5H8V1.5H0V0.5Z", "fill", "#191919"], ["d", "M4.40294 5.26376L0.343235 1.4147C0.15219 1.23357 0.15219 0.91659 0.343235 0.735458C0.53428 0.554326 0.868608 0.554326 1.05965 0.735458L4.88055 4.3581L8.94025 0.735458C9.1313 0.554326 9.46562 0.554326 9.65667 0.735458C9.84771 0.91659 9.84771 1.23357 9.65667 1.4147L5.35816 5.26376C5.21488 5.39961 5.07159 5.39961 4.92831 5.39961C4.6895 5.39961 4.49846 5.35433 4.40294 5.26376Z", "fill", "#191919"]],
      template: function NumericSelectorComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r5 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "input", 2, 3);
          i0.ɵɵlistener("input", function NumericSelectorComponent_Template_input_input_2_listener() {
            i0.ɵɵrestoreView(_r5);
            const _r0 = i0.ɵɵreference(3);
            return i0.ɵɵresetView(ctx.onInput(_r0.value));
          })("blur", function NumericSelectorComponent_Template_input_blur_2_listener() {
            return ctx.onBlur();
          })("mouseup", function NumericSelectorComponent_Template_input_mouseup_2_listener() {
            return ctx.onMouseUp();
          })("focusout", function NumericSelectorComponent_Template_input_focusout_2_listener() {
            return ctx.onFocusOut();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", 4)(5, "div")(6, "button", 5);
          i0.ɵɵlistener("click", function NumericSelectorComponent_Template_button_click_6_listener() {
            return ctx.increment();
          });
          i0.ɵɵtemplate(7, NumericSelectorComponent__svg_svg_7_Template, 2, 0, "svg", 6)(8, NumericSelectorComponent__svg_svg_8_Template, 2, 0, "svg", 7);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "button", 8);
          i0.ɵɵlistener("click", function NumericSelectorComponent_Template_button_click_9_listener() {
            return ctx.decrement();
          });
          i0.ɵɵtemplate(10, NumericSelectorComponent__svg_svg_10_Template, 2, 0, "svg", 9)(11, NumericSelectorComponent__svg_svg_11_Template, 2, 0, "svg", 7);
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelementStart(12, "p", 10);
          i0.ɵɵtext(13);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("error-border", ctx.errorMessageText)("mouse-focus", ctx.mouseFocused);
          i0.ɵɵproperty("step", ctx.step)("value", ctx.value)("min", ctx.min)("required", ctx.required)("name", ctx.name)("max", ctx.max)("placeholder", ctx.placeholder)("disabled", ctx.disabled);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.buttonType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.buttonType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("disabled", ctx.disabled);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.buttonType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.buttonType);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.errorMessageText, " ");
        }
      },
      dependencies: [i1.NgIf],
      styles: [".sol-numeric-selector .numeric-input-wrapper{display:flex;height:2.25rem}.sol-numeric-selector .numeric-input-wrapper input{min-width:1.375rem;max-width:4.125rem;padding-left:.75rem;border:1px solid var(--color-globalstate-inactive-border);background:#fff;border-radius:4px 0 0 4px;outline:none;-moz-appearance:textfield}.sol-numeric-selector .numeric-input-wrapper input::-webkit-outer-spin-button,.sol-numeric-selector .numeric-input-wrapper input::-webkit-inner-spin-button{-webkit-appearance:none}.sol-numeric-selector .numeric-input-wrapper input:hover{border-color:var(--color-globalstate-hover-border);background:var(--color-globalstate-hover-background)}.sol-numeric-selector .numeric-input-wrapper input:focus-visible{z-index:1;outline-offset:4px;outline:1px solid var(--color-globalstate-focus)}.sol-numeric-selector .numeric-input-wrapper input:disabled{border-color:var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background)}.sol-numeric-selector .numeric-input-wrapper input:disabled:hover{border-color:var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background)}.sol-numeric-selector .numeric-input-wrapper input.mouse-focus{outline:none}.sol-numeric-selector .numeric-input-wrapper input:active:focus-visible{outline:none}.sol-numeric-selector .numeric-input-wrapper .error-border,.sol-numeric-selector .numeric-input-wrapper .error-border:hover{border-color:var(--color-interface-error600)}.sol-numeric-selector .numeric-input-wrapper .error-border:focus{border-color:var(--color-interface-error600)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons{display:grid;align-content:center;height:2.25rem}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button{padding:0;height:1.125rem;width:1.25rem;background:var(--color-interface-background50);border-radius:0;border:1px solid var(--color-globalstate-inactive-border);border-left:none;display:flex;justify-content:center;align-content:center;flex-wrap:wrap}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:hover{background:var(--color-interface-background100)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:active{background:var(--color-interface-background125)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:focus-visible{background:var(--color-interface-background100);outline:1px solid var(--color-globalstate-focus);outline-offset:4px}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:disabled{border-color:var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background);color:var(--color-interface-text700)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:disabled:hover{background:var(--color-globalstate-disabled-background)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons .top-button{border-radius:0 4px 0 0}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons .bottom-button{border-top:none;border-radius:0 0 4px}.sol-numeric-selector .error-message{color:var(--color-interface-error600);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);margin-top:.25rem}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumericSelectorComponent, [{
    type: Component,
    args: [{
      selector: 'sol-numeric-selector',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: NumericSelectorComponent,
        multi: true
      }],
      template: "<div class=\"sol-numeric-selector\">\n  <div class=\"numeric-input-wrapper\">\n    <input\n      type=\"number\"\n      [class.error-border]=\"errorMessageText\"\n      [class.mouse-focus]=\"mouseFocused\"\n      [step]=\"step\"\n      [value]=\"value\"\n      [min]=\"min\"\n      [required]=\"required\"\n      [name]=\"name\"\n      [max]=\"max\"\n      [placeholder]=\"placeholder\"\n      #numericInput\n      (input)=\"onInput(numericInput.value)\"\n      (blur)=\"onBlur()\"\n      [disabled]=\"disabled\"\n      (mouseup)=\"onMouseUp()\"\n      (focusout)=\"onFocusOut()\"\n    />\n\n    <div class=\"numeric-buttons\">\n      <div>\n        <button (click)=\"increment()\" aria-label=\"increment button\" class=\"top-button\" [disabled]=\"disabled\">\n          <svg *ngIf=\"buttonType\" width=\"8\" height=\"8\" viewBox=\"0 0 8 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M8 3.5H4.5V0H3.5V3.5H0V4.5H3.5V8H4.5V4.5H8V3.5Z\" fill=\"#191919\" />\n          </svg>\n          <svg *ngIf=\"!buttonType\" width=\"10\" height=\"6\" viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path\n              d=\"M5.59706 0.73624L9.65677 4.5853C9.84781 4.76643 9.84781 5.08341 9.65677 5.26454C9.46572 5.44567 9.13139 5.44567 8.94035 5.26454L5.11945 1.6419L1.05975 5.26454C0.868705 5.44567 0.534376 5.44567 0.343331 5.26454C0.152287 5.08341 0.152286 4.76643 0.343331 4.5853L4.64184 0.73624C4.78512 0.600391 4.92841 0.600391 5.07169 0.600391C5.3105 0.600391 5.50154 0.645674 5.59706 0.73624Z\"\n              fill=\"#191919\"\n            />\n          </svg>\n        </button>\n        <button (click)=\"decrement()\" aria-label=\"decrement button\" class=\"bottom-button\" [disabled]=\"disabled\">\n          <svg *ngIf=\"buttonType\" width=\"8\" height=\"2\" viewBox=\"0 0 8 2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path d=\"M0 0.5H8V1.5H0V0.5Z\" fill=\"#191919\" />\n          </svg>\n          <svg *ngIf=\"!buttonType\" width=\"10\" height=\"6\" viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path\n              d=\"M4.40294 5.26376L0.343235 1.4147C0.15219 1.23357 0.15219 0.91659 0.343235 0.735458C0.53428 0.554326 0.868608 0.554326 1.05965 0.735458L4.88055 4.3581L8.94025 0.735458C9.1313 0.554326 9.46562 0.554326 9.65667 0.735458C9.84771 0.91659 9.84771 1.23357 9.65667 1.4147L5.35816 5.26376C5.21488 5.39961 5.07159 5.39961 4.92831 5.39961C4.6895 5.39961 4.49846 5.35433 4.40294 5.26376Z\"\n              fill=\"#191919\"\n            />\n          </svg>\n        </button>\n      </div>\n    </div>\n  </div>\n  <p class=\"error-message\">\n    {{ errorMessageText }}\n  </p>\n</div>\n",
      styles: [".sol-numeric-selector .numeric-input-wrapper{display:flex;height:2.25rem}.sol-numeric-selector .numeric-input-wrapper input{min-width:1.375rem;max-width:4.125rem;padding-left:.75rem;border:1px solid var(--color-globalstate-inactive-border);background:#fff;border-radius:4px 0 0 4px;outline:none;-moz-appearance:textfield}.sol-numeric-selector .numeric-input-wrapper input::-webkit-outer-spin-button,.sol-numeric-selector .numeric-input-wrapper input::-webkit-inner-spin-button{-webkit-appearance:none}.sol-numeric-selector .numeric-input-wrapper input:hover{border-color:var(--color-globalstate-hover-border);background:var(--color-globalstate-hover-background)}.sol-numeric-selector .numeric-input-wrapper input:focus-visible{z-index:1;outline-offset:4px;outline:1px solid var(--color-globalstate-focus)}.sol-numeric-selector .numeric-input-wrapper input:disabled{border-color:var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background)}.sol-numeric-selector .numeric-input-wrapper input:disabled:hover{border-color:var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background)}.sol-numeric-selector .numeric-input-wrapper input.mouse-focus{outline:none}.sol-numeric-selector .numeric-input-wrapper input:active:focus-visible{outline:none}.sol-numeric-selector .numeric-input-wrapper .error-border,.sol-numeric-selector .numeric-input-wrapper .error-border:hover{border-color:var(--color-interface-error600)}.sol-numeric-selector .numeric-input-wrapper .error-border:focus{border-color:var(--color-interface-error600)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons{display:grid;align-content:center;height:2.25rem}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button{padding:0;height:1.125rem;width:1.25rem;background:var(--color-interface-background50);border-radius:0;border:1px solid var(--color-globalstate-inactive-border);border-left:none;display:flex;justify-content:center;align-content:center;flex-wrap:wrap}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:hover{background:var(--color-interface-background100)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:active{background:var(--color-interface-background125)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:focus-visible{background:var(--color-interface-background100);outline:1px solid var(--color-globalstate-focus);outline-offset:4px}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:disabled{border-color:var(--color-globalstate-disabled-borderalt);background:var(--color-globalstate-disabled-background);color:var(--color-interface-text700)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons button:disabled:hover{background:var(--color-globalstate-disabled-background)}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons .top-button{border-radius:0 4px 0 0}.sol-numeric-selector .numeric-input-wrapper .numeric-buttons .bottom-button{border-top:none;border-radius:0 0 4px}.sol-numeric-selector .error-message{color:var(--color-interface-error600);font-size:var(--typography-opensans-body-body4-font-size);font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);line-height:var(--typography-opensans-body-body4-line-height);margin-top:.25rem}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Renderer2
  }], {
    value: [{
      type: Input
    }],
    step: [{
      type: Input
    }],
    buttonType: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    errorMessageText: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    valueChange: [{
      type: Output
    }],
    numericInput: [{
      type: ViewChild,
      args: ['numericInput', {
        static: false
      }]
    }]
  });
})();
class NumericSelectorModule {
  static {
    this.ɵfac = function NumericSelectorModule_Factory(t) {
      return new (t || NumericSelectorModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NumericSelectorModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumericSelectorModule, [{
    type: NgModule,
    args: [{
      declarations: [NumericSelectorComponent],
      imports: [CommonModule],
      exports: [NumericSelectorComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of numeric-selector
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NumericSelectorComponent, NumericSelectorModule };
